<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>
        Da li ste sigurni da sa infrastrukture želite da obrišete servisera:
      </p>
      <p class="filename">{{ contractor.contractor.name }}</p>
    </div>
    <hr />
    <div class="footer">
      <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">
        Otkaži
      </button>
      <button
        type="submit"
        class="btn btn-primary btn--mod"
        @click="deleteInfrastructureContractor"
        :disabled="loading"
      >
        <span v-if="!loading">Potvrdi</span>
        <spinner line-fg-color="#00796b" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  computed: {
    ...mapState('modal', ['contractor', 'infrastructure']),
    ...mapState(['loading'])
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', [
      'closeModal',
      'removeContractor',
      'removeInfrastructure'
    ]),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapActions('table', ['getInfrastructureById']),
    deleteInfrastructureContractor() {
      if (this.loading) {
        return;
      }
      this.loadingStarted();
      const data = {
        memberId: this.$store.getters.getActiveCommunity.member_id
      };
      axios
        .delete(
          `infrastructure/contractor/${
            this.contractor.infrastructure_contractor_id
          }`,
          {
            data: data
          }
        )
        .then(async () => {
          await this.getInfrastructureById(this.infrastructure.id);
          this.loadingFinished();
          this.removeInfrastructure();
          this.removeContractor();
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(e => {
          console.log('eer', e);
          this.loadingFinished();
          this.showFailModal();
        });
    }
  }
};
</script>

<style scoped>
.filename {
  word-break: break-word;
}
</style>
